import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router";

import {
  individualStoreProfileConstants,
} from "../../constants";
import { useSpinner, Spinner, handleAsyncAction } from "../../../../shared";
import { individualStoreProfileActions } from "../../redux/actions";
import ImportOrder from "../../../../shared/components/ImportOrder/ImportOrder";

const { FETCH_GENERAL_DATA } = individualStoreProfileConstants;

//Profile screen for a specific store against a brand
const IndividualStoreProfile = (props) => {
  const { user, profileData, getBrandId, getlocationId, getStoreProfileData } =
    props;

  const { brandId, locationId } = useParams();

  // Show loading while a request is running.
  const spinner = useSpinner();

  const fetchData = () => {
    if (locationId) {
      handleAsyncAction(getStoreProfileData(locationId, false));
      getlocationId(locationId);
      getBrandId(brandId || user.brandId);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locationId]);

  return (
    <>
      {spinner(FETCH_GENERAL_DATA) ? (
        <Spinner />
      ) : (
        <div className="container-fluid py-3">
          <div className="notificationForm shadow card border-0">
            <div className="card-body p-0">
              <div className="row ps-4 py-2">
                <div className="col-6">
                  <h5 className="ps-4 py-3 mb-0">General</h5>
                </div>
                <div className="col-6 d-none">
                  <ImportOrder />
                </div>
              </div>
              <hr className="my-0" />
              <div className="row mb-3 g-0">
                <div className="col-12">
                  <div className="row m-2">
                    <div className="col-lg-5 col-12 row py-md-auto py-1">
                      <span className="col-lg-3 col-12 d-inline-block survey_profile_labels pe-2">
                        Name:
                      </span>
                      <span className="col-lg-9 col-12 profile_lable_values">
                        {profileData.name}
                      </span>
                    </div>
                    <div className="col-lg-7 col-12 row py-md-auto py-1">
                      <span className="col-lg-3 col-12 d-inline-block survey_profile_labels pe-2">
                        Address:
                      </span>
                      <span className="col-lg-9 col-12 profile_lable_values">
                        {profileData.address}
                      </span>
                    </div>
                  </div>

                  <div className="row m-2">
                    <div className="col-lg-5 col-12 row py-md-auto py-1">
                      <span className="col-lg-3 col-12 d-inline-block survey_profile_labels pe-2">
                        Phone:
                      </span>
                      <span className="col-lg-9 col-12 profile_lable_values">
                        {profileData.phone}
                      </span>
                    </div>
                    <div className="col-lg-7 col-12 row">
                      <span className="col-lg-3 col-12 d-inline-block survey_profile_labels pe-2">
                        Domain Name:
                      </span>
                      <span className="col-lg-9 col-12 profile_lable_values">
                        {profileData.domainName}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  user: state.authentication.user,
  locationId: state.individualStoreProfileReducer.locationId,
  profileData: state.individualStoreProfileReducer.profileData,
});

const mapDispatchToProps = (dispatch) => ({
  getStoreProfileData: (locationId, fromFR) =>
    dispatch(
      individualStoreProfileActions.getStoreProfileData(locationId, fromFR)
    ),
  getlocationId: (restaurantId) =>
    dispatch(individualStoreProfileActions.locationId(restaurantId)),
  getBrandId: (brandId) =>
    dispatch(individualStoreProfileActions.getBrandId(brandId)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IndividualStoreProfile);
